export const handleHoverStateFor = (flexyInstance) => {
  const sliderContainer = flexyInstance.sliderContainer

  if (!flexyInstance.options.autoplay) return

  sliderContainer.addEventListener(
    "mouseenter",
    () =>
      (flexyInstance.options = {
        ...flexyInstance.options,
        autoplay: false,
        _autoplay: flexyInstance.options.autoplay,
      })
  )

  sliderContainer.addEventListener("mouseleave", () => {
    flexyInstance.options = {
      ...flexyInstance.options,
      autoplay: flexyInstance.options._autoplay,
      _autoplay: false,
    }

    flexyInstance.state = {
      ...flexyInstance.state,
      lastTimeAnimated: new Date().getTime(),
    }
  })
}
